import * as serviceWorker from './base/serviceWorker';
// import './instrument';

import { createRoot } from 'react-dom/client';
import { config } from './config';
import TagManager from 'react-gtm-module';
import AppContainer from './base/components/AppContainer';
import { insertHeadLinks } from './insertHeadLinks';

// Stylesheets
import './base/assets/scss/libs.scss';

if (typeof config['google.gtm'] !== 'undefined') {
  TagManager.initialize({
    gtmId: config['google.gtm'],
  });
}

insertHeadLinks()

sessionStorage.removeItem('cachedAvail');

const root = createRoot(document.getElementById('root'));
root.render(<AppContainer />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
